import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinArrayString',
    standalone: false
})
export class JoinArrayStringPipe implements PipeTransform {

  constructor() { }

  transform(value: ReadonlyArray<string>, delimiter: string): string {
    return value.join(delimiter);
  }
}